import { store, storeActions } from '~/utility/BinSentry-ui-utility';
import { LitEntity, renderIf, html, css } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import '../common/bn-action';
import '../common/bn-surface';
import '../common/bn-loading';
import '../tags/tag-list';
import './actions/update-organization';
import './actions/organization-delete-button';

class OrganizationActions extends LitEntity {
  constructor() {
    super();
    this.tagsHref = '';
  }

  static get properties() {
    return {
      tagsHref: { type: String },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: flex;
        flex-flow: row wrap;
        margin: 0 calc(var(--root-margin) / 2);
      }
      :host > * {
        margin: 0 calc(var(--root-margin) / 2);
      }
      .org-parent {
        cursor: pointer;
      }
      .actions {
        background-color: var(--blue-40);
        padding: 8px;
        margin-top: 4px;
        text-align: center;
      }
      .admin input {
        width: 100%;
      }
      .admin .form-field {
        margin-bottom: 0;
      }
      .right-column,
      .left-column {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        flex-direction: column;
        flex-shrink: 1;
        flex-grow: 1;
        width: calc(33% - 32px);
      }
      .right-column bn-surface,
      .left-column bn-surface {
        box-sizing: border-box;
        width: 100%;
        margin: var(--root-margin) 0;
      }
      .right-column {
        width: calc(66% - 32px);
        flex-grow: 1;
        min-width: 400px;
      }
    `];
  }

  render() {
    if (this.loading) {
      return html`<bn-loading></bn-loading>`;
    }

    if (!this.entity) {
      return html``;
    }

    return html`
      ${this._renderLeft()}

      <div class="right-column">
        <bn-surface class="organization-id-surface">
          <div class="admin">
            <div class="form-field">
              <label>Organization ID</label>
              <input type="text" disabled value="${this.href}" />
            </div>
          </div>
        </bn-surface>

        ${renderIf(this.entity.hasAction('update-address'), () => html`
          <bn-surface>
            <bn-action
              .href="${this.href}"
              actionname="update-address"
              submittext="Update"
              buttonstyle="outlined"
              successtext="Address has been updated."
              errortext="Could not update address."
            >
              <h3 slot="header">Update Address</h3>
            </bn-action>
          </bn-surface>
        `)}

        ${renderIf(this.tagsHref, () => html`
          <bn-surface class="tags-container">
            <h3>Update Tags</h3>
            <tag-list .href="${this.tagsHref}"></tag-list>
          </bn-surface>
        `)}

        ${renderIf(this.entity.hasAction('update-settings'), () => html`
          <bn-surface>
            <bn-action
              .href="${this.href}"
              actionname="update-settings"
              submittext="Update"
              buttonstyle="outlined"
              successtext="Settings have been updated."
              errortext="Could not update settings."
            >
              <h3 slot="header">Update Settings</h3>
            </bn-action>
          </bn-surface>
        `)}
      </div>
    `;
  }

  _renderLeft() {
    const actions = [];
    if (this.entity.hasAction('update-organization')) {
      actions.push(html`
        <bn-surface>
          <update-organization .href="${this.href}"></update-organization>
        </bn-surface>
      `);
    }
    if (this.entity.hasAction('update-structure')) {
      actions.push(html`
        <bn-surface>
          <bn-action
            .href="${this.href}"
            actionname="update-structure"
            submittext="Update"
            buttonstyle="outlined"
            successtext="Organization structure has been updated."
            errortext="Could not update organization structure."
          >
            <h3 slot="header">Update Structure</h3>
          </bn-action>
        </bn-surface>
      `);
    }
    if (this.entity.hasAction('update-features')) {
      actions.push(html`
        <bn-surface>
          <bn-action
            .href="${this.href}"
            actionname="update-features"
            submittext="Update"
            buttonstyle="outlined"
            successtext="Organization features have been updated."
            errortext="Could not update organization features."
          >
            <h3 slot="header">Update Features</h3>
          </bn-action>
        </bn-surface>
      `);
    }
    if (this.entity.hasAction('move-organization')) {
      actions.push(html`
        <bn-surface>
          <bn-action
            .href=${this.href}
            actionname="move-organization"
            submittext="Move"
            buttonstyle="outlined"
            successtext="Organization has been moved."
            errortext="Could not move organization."
          ></bn-action>
        </bn-surface>
      `);
    }
    if (this.entity.hasAction('create-partner-warehouse-in-odoo')) {
      actions.push(html`
        <bn-surface>
          <bn-action
            .href=${this.href}
            actionname="create-partner-warehouse-in-odoo"
          ></bn-action>
        </bn-surface>
      `);
    }
    if (this.entity.hasAction('begin-delete')) {
      actions.push(html`
        <bn-surface>
          <h3>Delete Organization</h3>
          <organization-delete-button .href="${this.href}"></organization-delete-button>
        </bn-surface>
      `);
    }

    if (!actions.length) {
      return html``;
    }

    return html`<div class="left-column">${actions}</div>`;
  }

  _switchTo(href) {
    store.dispatch(storeActions.changeOrg(href));
    store.dispatch(storeActions.navigate('/organizations/list'));
  }
}

window.customElements.define('organization-actions', OrganizationActions);
